import React from "react";
import { SearchDropdownForm, SearchItemConfig } from "src/components/Form/search-dropdown-form";
import { Lounge } from "../../types/lounge.entity";
import { CurrencyCode } from "src/utils/util.types";

type Props = {
  updateFilterQuery: (filter: LoungeSearchRouteState) => void;
  initialQuery?: LoungeSearchRouteState;
};

export type LoungeSearchRouteState = {
  id?: string;
  user?: string;
  language?: string;
  status?: Lounge["status"];
  currency?: CurrencyCode;
};

const searchItems: Record<string, SearchItemConfig> = {
  id: {
    type: "input",
    placeholder: "Enter Lounge Id",
  },
  user: {
    type: "input",
    placeholder: "Enter a User ID, email address, or phone number",
  },
  language: {
    type: "input",
    placeholder: "Enter a language code, e.g., en or nl",
  },
  status: {
    type: "select",
    placeholder: "All Status",
    options: [
      { value: "STANDBY", text: "Standby" },
      { value: "ACCEPTED", text: "Accepted" },
      { value: "EXPIRED", text: "Expired" },
      { value: "CANCELLED", text: "Cancelled" },
    ],
  },
  currency: {
    type: "select",
    placeholder: "All",
    options: [
      {
        value: "KARMA",
        text: "karma",
      },
      {
        value: "EUR",
        text: "euro",
      },
    ],
  },
};

export const LoungeSearch: React.FC<Props> = ({ updateFilterQuery, initialQuery = {} }) => {
  const handleSubmit = (key: keyof typeof searchItems, value: string) => {
    updateFilterQuery({
      ...initialQuery,
      [key]: value || undefined,
    });
  };

  const activeFilters = [
    initialQuery.id ? { key: "id", label: "Id", value: initialQuery.id } : null,
    initialQuery.user ? { key: "user", label: "User", value: initialQuery.user } : null,
    initialQuery.language ? { key: "language", label: "Language", value: initialQuery.language } : null,
    initialQuery.status ? { key: "status", label: "Status", value: initialQuery.status } : null,
    initialQuery.currency ? { key: "currency", label: "Currency", value: initialQuery.currency } : null,
  ].filter(Boolean) as { key: keyof typeof searchItems; label: string; value: string }[];

  return (
    <div className="pt-5 pb-7">
      <SearchDropdownForm
        searchItems={searchItems}
        handleSubmit={handleSubmit}
        activeFilters={activeFilters}
        onRemoveFilter={(key) => updateFilterQuery({ ...initialQuery, [key]: undefined })}
        onClearAll={() => updateFilterQuery({})}
      />
    </div>
  );
};
